<bb-filters [filterConfig]="filterConfig" [currentPath]="'/library/playoutNG6/1192/miscellaneous'" [search]="true"
	[lightBackground]="true"></bb-filters>

<bb-table-container>

	<bb-table-header>
		<bb-table-header-cell class="thumb"></bb-table-header-cell>
		<bb-table-header-cell class="icon"></bb-table-header-cell>
		<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="status" class="column-statusicon">&nbsp;</bb-table-header-cell>
		<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
	</bb-table-header>

	<bb-table-row *ngFor="let row of rows" [row]="row">
		<bb-table-cell class="thumb"><bb-table-thumbnail [entity]="row.data"></bb-table-thumbnail>
		</bb-table-cell>
		<bb-table-cell><span style="white-space: no-break;"><span [innerHTML]="row.data | clipIcon"></span><strong
					[hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;"
					title="Creative">C</strong></span></bb-table-cell>
		<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
		<bb-table-cell property="title" class="overflow">
			<span [hidden]="!row?.data?.title">{{ row.data.title }}</span>
			<span [hidden]="row?.data?.title" class="filename">{{ row.data.originalfilename }}</span>
		</bb-table-cell>
		<bb-table-cell property="status" class="column-statusicon">
			<div [innerHtml]="row.data | statusIcon"></div>
		</bb-table-cell>
		<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
	</bb-table-row>

</bb-table-container>

<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

<bb-table-pager></bb-table-pager>

<div class="buttons">
	<span class="button" (click)="cancelClicked()"><i class="fa fa-ban"></i>{{ 'CANCEL' | translate }}</span>
	<span class="button" (click)="selectClicked()" [class.disabled]="!selectedMediaclipFromTable"><i
			class="fa fa-link"></i>{{ 'SELECT' | translate }}</span>
</div>